import React from 'react';
import { PUBLIC_IMG_URL } from '../../../../lib/endpoints';

const FEATURES = [
    { name: 'Find Startups',                  img: 'Startups.svg',    link: '/startups' },
    { name: 'Find Investors',                 img: 'Investors.svg',   link: '/investors' },
    { name: 'Private Equity Data',            img: 'Equity.svg',      link: '/private-equity' },
    { name: 'Real-Time Trends & Comparisons', img: 'comparison.svg',  link: '/advanced-analytics' },
    { name: 'Custom Dashboard',               img: 'dashboard.svg',   link: '/client-directory' },
    { name: 'Research',                       img: 'Research.svg',    link: '/research' },
];

export default function Features() {
    return (
        <section className="lp-features">
            <h2 className="lp-features__title">
                Everything you need to navigate emerging markets
            </h2>
            <div className="lp-features__grid">
                {FEATURES.map((f, i) => (
                    <a className="lp-feature-card" href={f.link} key={i}>
                        <img
                            className="lp-feature-card__icon"
                            src={`${PUBLIC_IMG_URL}/anonymous-landing-page/${f.img}`}
                            alt={f.name}
                        />
                        <div className="lp-feature-card__bottom">
                            <span className="lp-feature-card__name">{f.name}</span>
                            <i className="fas fa-arrow-right ml-2 lp-feature-card__arrow"></i>
                        </div>
                    </a>
                ))}
            </div>
        </section>
    );
}
